import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import CipherPage from './pages/CipherPage';
import LoginPage from './pages/LoginPage';
import DictionaryPage from './pages/DictionaryPage';
import AdminPage from './pages/AdminPage';
import AppSettingsPage from './pages/AppSettingsPage';
import AiUsagePage from './pages/AiUsagePage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import MeetingsPage from './pages/MeetingsPage';
import MeetingWorkspace from './pages/MeetingWorkspace';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AuthBypassWatermark from './components/AuthBypassWatermark';
import './styles/index.css';

const AppContent = () => {
  const { authBypassActive } = useAuth();

  return (
    <div className="app-shell">
      {authBypassActive && <AuthBypassWatermark />}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#10b981',
            },
          },
          error: {
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout>
                <CipherPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dictation"
          element={
            <ProtectedRoute>
              <Layout>
                <CipherPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/dictionary"
          element={
            <ProtectedRoute>
              <Layout>
                <DictionaryPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/meetings"
          element={
            <ProtectedRoute>
              <Layout>
                <MeetingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/meetings/:sessionId"
          element={
            <ProtectedRoute>
              <Layout>
                <MeetingWorkspace />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Layout>
                <SettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/help"
          element={
            <ProtectedRoute>
              <Layout>
                <HelpPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireAdmin>
              <Layout>
                <AdminPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/settings"
          element={
            <ProtectedRoute requireAdmin>
              <Layout>
                <AppSettingsPage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/ai-usage"
          element={
            <ProtectedRoute requireAdmin>
              <Layout>
                <AiUsagePage />
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
